import { render } from "./ViewEditor.vue?vue&type=template&id=b376a9a6&scoped=true"
import script from "./ViewEditor.vue?vue&type=script&lang=ts"
export * from "./ViewEditor.vue?vue&type=script&lang=ts"

import "./ViewEditor.vue?vue&type=style&index=0&id=b376a9a6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-b376a9a6"

export default script